/* eslint-disable new-cap */
import Phaser from 'phaser';
import ABCyaLib from '@abcya/abcya_lib';
import AudioPlayer from '../library/AudioPlayer';
import Doors from '../objects/Doors';
import MainMenu from './MainMenu';
import gameData from '../gameData';

export default class DoorScene extends Phaser.Scene {
  static get KEY() {return 'DoorScene';}

  create() {
    this.doors = new Doors(this);

    gameData.config = ABCyaLib.Environment.instance.gameConfig;

    this.scene.run(MainMenu.KEY);

    // this.scene.run('Game');
    // this.scene.run('Bonus');

    // this.scene.run('Win');

    // this.scene.run('LevelSelect');

    AudioPlayer.PlaySound(this, AudioPlayer.sounds.JINGLE, true);

    this.scene.bringToTop(DoorScene.KEY);
  }

  /**
   * 
   * @param {Phaser.Scene.KEY} closeScene 
   * @param {Phaser.Scene.KEY} nextScene 
   */
  changeScene(closeScene, nextScene) {
    const tween = this.doors.AnimateIn();
    tween.on('complete', () => {
      this.scene.stop(closeScene);
      this.scene.run(nextScene);
      this.scene.bringToTop(DoorScene.KEY);

      this.doors.AnimateOut();
    });
  }

  animateDoors(closeScene, nextScene) {
    const tween = this.doors.AnimateIn();
    tween.on('complete', () => {
      this.scene.stop(closeScene);
      this.scene.run(nextScene);
      this.scene.bringToTop(DoorScene.KEY);

      this.doors.AnimateOut();
    });
  }
}